import axios from "axios";
import config from "../config/apiConfig";

// Get the current authenticated user
export const getCurrentUser = async () => {
    try {
        const response = await axios.get(`${config.API_BASE_URL}/auth/user`);
        return response.data.user;
    } catch (error) {
        console.error("Error fetching current user:", error);
        throw error;
    }
};

// Sign In
export const signIn = async (email, password) => {
    try {
        const response = await axios.post(`${config.API_BASE_URL}/auth/login`, {
            email,
            password,
        });
        // Store the token or any necessary user data in localStorage or cookies
        localStorage.setItem("authToken", response.data.token);
        return response.data.data;
    } catch (error) {
        console.error("Error signing in:", error);
        throw error;
    }
};

// Forgot Password - Step 1: Send OTP
export const forgotPassword = async (email) => {
    try {
        const response = await axios.post(`${config.API_BASE_URL}/auth/forgot-password`, {
            email,
        });
        return response.data.message;
    } catch (error) {
        console.error("Error in forgot password:", error);
        throw error;
    }
};

// Reset Password - Step 2: Use OTP and New Password
export const resetPassword = async (email, otp, newPassword) => {
    try {
        const response = await axios.post(`${config.API_BASE_URL}/auth/reset-password`, {
            email,
            otp,
            newPassword,
        });
        return response.data.message;
    } catch (error) {
        console.error("Error resetting password:", error);
        throw error;
    }
};

// Sign Out
export const signOut = async () => {
    try {
        await axios.post(`${config.API_BASE_URL}/auth/logout`, {});
        localStorage.removeItem("authToken");
    } catch (error) {
        console.error("Error signing out:", error);
        throw error;
    }
};
